export default __webpack_public_path__ + "static/nj-skyline-5334db966e1e648a501fa1fc9c29fb27.webp";